import Demo from '../../../views/corp/demo/Demo'

const demoRoutes = [
  {
    path: '/corp/demo',
    element: <Demo />
  }
]

export default demoRoutes
